module.exports = __webpack_public_path__ + "media/images/lb/464-f7152b8d7ba2cde477409a58b2d5c790.svg";